import { sendMessage, BaseMessage, hasAppApi } from './Communication';

interface InformationMessage extends BaseMessage {
    type: 'information';
}

interface AppInfoRequest extends InformationMessage {
    action: 'app_info';
}

export interface ApiVersion {
    major: number;
    minor: number;
}

export interface AppVersion extends ApiVersion {
    patch: number;
    build: number;
}

export interface AppInfo {
    api_version: Readonly<ApiVersion>;
    app_version: Readonly<AppVersion>;
    app_protocol: string;
    initialization_url: string;
    production_url: string;
    status_bar_height: number;
    ar_device: boolean;
    localization_settings?: {
      country_code: string;
      currency_code: string;
      language_code: string;
    };
}

export function getAppInfo(timeout?: number): Promise<AppInfo> {
    return sendMessage<AppInfoRequest, AppInfo>(
        {
            type: 'information',
            action: 'app_info'
        },
        undefined,
        timeout
    );
}

export let appInfo: Readonly<AppInfo> | undefined | null;

export async function initializeAppInfo(timeout?: number): Promise<void> {
    if (appInfo === undefined && hasAppApi()) {
        try {
            appInfo = await getAppInfo(timeout);
        } catch {
            appInfo = null;
        }
    }
}

export function isWindowsApp(): boolean {
    return (appInfo != null && window.navigator.userAgent.match(/[wW]indows/) != null);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Information.ts